import{a as e}from"./chunk-VYXSAUBQ.js";import{g as r,m as o}from"./chunk-HBP5N4FR.js";var a={};r(a,{UnlockPage:()=>e});o();export{a};
//# sourceMappingURL=chunk-BYSH3UW5.js.map
